export default __webpack_public_path__ + "static/media/instant-award.4f1270f0.jpeg";